"use client";

import { Lipsync } from "wawa-lipsync";

// Create lipsync manager at module level (similar to lipsync-demo)
let lipsyncManager: Lipsync;

if (typeof window !== 'undefined') {
  lipsyncManager = new Lipsync();
}

export const getLipsyncManager = (): Lipsync => {
  if (typeof window === 'undefined') {
    throw new Error('Lipsync can only be used on the client side');
  }
  return lipsyncManager;
};

export { lipsyncManager };
